import { LoaderMessage } from "../../../../../components/loaderMessage/loaderMessage";
import { PANEL_SUBTITLES } from "../utils/constants";
import { ConfigurationType, RuleType, SubRuleType } from "../utils/types";
import RulePanel from "./RulePanel";

interface MnRulesContentProps {
  isLoading: boolean;
  error: string | null;
  configurationType: ConfigurationType;
  selectedDrugId: string | null;
  ruleType: RuleType;
  mcqRules: string[];
  subjectiveRules: string[];
  mcqSearch: string;
  onMcqSearchChange: (v: string) => void;
  subjectiveSearch: string;
  onSubjectiveSearchChange: (v: string) => void;
  onAddRule: (subType: SubRuleType | "flat", panelLabel: string) => void;
  onEditRule: (
    subType: SubRuleType | "flat",
    index: number,
    newText: string,
  ) => void;
  onDeleteRule: (subType: SubRuleType | "flat", index: number) => void;
}

const MnRulesContent = ({
  isLoading,
  error,
  configurationType,
  selectedDrugId,
  ruleType,
  mcqRules,
  subjectiveRules,
  mcqSearch,
  onMcqSearchChange,
  subjectiveSearch,
  onSubjectiveSearchChange,
  onAddRule,
  onEditRule,
  onDeleteRule,
}: MnRulesContentProps) => {
  if (isLoading) {
    return (
      <div className="flex-1">
        <LoaderMessage message="Loading rules..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-shrink-0 rounded border border-red-200 bg-red-50 px-3 py-2 text-small text-red-700">
        {error}
      </div>
    );
  }

  if (configurationType === "drug_specific" && !selectedDrugId) {
    return (
      <div className="flex flex-1 items-center justify-center text-h12 text-primaryGray-8">
        Select a drug to view or edit its rules
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 gap-4 overflow-hidden">
      <RulePanel
        title="MCQ"
        subtitle={PANEL_SUBTITLES[ruleType].mcq}
        rules={mcqRules}
        onAddRule={() => onAddRule("mcq", "MCQ")}
        onEditRule={(i, newText) => onEditRule("mcq", i, newText)}
        onDeleteRule={(i) => onDeleteRule("mcq", i)}
        searchQuery={mcqSearch}
        onSearchChange={onMcqSearchChange}
      />
      <RulePanel
        title="Subjective"
        subtitle={PANEL_SUBTITLES[ruleType].subjective}
        rules={subjectiveRules}
        onAddRule={() => onAddRule("subjective", "Subjective")}
        onEditRule={(i, newText) => onEditRule("subjective", i, newText)}
        onDeleteRule={(i) => onDeleteRule("subjective", i)}
        searchQuery={subjectiveSearch}
        onSearchChange={onSubjectiveSearchChange}
      />
    </div>
  );
};

export default MnRulesContent;
